import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Nav, NavItem } from "reactstrap";
import home from "../../Assets/icons/home.svg";
import history from "../../Assets/icons/history.svg";
import question from "../../Assets/icons/question.svg";
import library from "../../Assets/icons/library.svg";
import faq from "../../Assets/icons/faq.svg";
import contactUs from "../../Assets/icons/contact-us.svg";
import logout from "../../Assets/icons/logout.svg";
import logo from "../../Assets/logo/logo.svg";
import avatar from "../../Assets/icons/avatar.svg";
import "./dashboard.scss";
import { IoClose } from "react-icons/io5";

const menuItems = [
  { name: "Home", path: "/dashboard/home", icon: home },
  { name: "Order History", path: "/dashboard/order-history", icon: history },
  // {
  //   name: "Exam Prep. History",
  //   path: "/dashboard/exam-prep-history",
  //   icon: question,
  // },
  {
    name: "Find My University?",
    path: "/dashboard/dashboard-university",
    icon: question,
  },
  // { name: "My Questions", path: "/dashboard/questions", icon: question },
  { name: "Subjects", path: "/dashboard/subjects", icon: library },
  { name: "FAQ's", path: "/dashboard/faq", icon: faq },
  { name: "Contact Us", path: "/dashboard/contact-us", icon: contactUs },
  { name: "Profile", path: "/dashboard/personal-info", icon: avatar },
  { name: "Logout", path: "/dashboard/contact-us", icon: logout },
];

const DashboardSidebarLeft = ({ setOpenSidebar }) => {
 const navigate = useNavigate();

   const handleLogout = () => {
    localStorage.removeItem("email");
    localStorage.removeItem("token");
    localStorage.removeItem("questionId");
    localStorage.removeItem("serviceType");
    navigate("/", { replace: true });
    window.location.reload();
  };

  const handleMenuClick=()=>[
    setOpenSidebar(false)
  ]
  return (
    <>
      <div className="sidebar-mobile-header">
        <img src={logo} alt="logo" className="sidebar-logo" />

        <IoClose
          size={26}
          className="sidebar-close"
          onClick={() => setOpenSidebar(false)}
        />
      </div>
      <Nav
        className="me-auto align-items-center justify-content-end w-100"
        navbar
        vertical
      >
        {menuItems.map((item, index) => (
          <NavItem
            key={index}
            className="px-3 w-100 d-flex justify-content-start ps-3 border-bottom py-3"
          >
            <NavLink
              to={item.path}
              className="menu nav-link d-flex align-items-center gap-4 ps-2 fs-3"
              onClick={item?.name === "Logout" ? handleLogout : handleMenuClick}>
              <img
                src={item.icon}
                alt={item.name}
                style={{ width: "20px", height: "20px" }}
              />
              <span className="link-text">{item.name}</span>
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </>
  );
};

export default DashboardSidebarLeft;
